<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Add Material Part</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
        <v-row justify="center" dense>
            <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Material</b></p>
                <v-autocomplete
                color="#0F2027"
                dense
                rounded
                required
                v-model="inventory_composite_material"
                :items="inventory_composite_material_list"
                item-text="name"
                item-value="id"
                label="Material"
                outlined
                />
        </v-col>
        </v-row>
        <v-row justify="center" dense v-if="inventory_composite_material">
            <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Material Part Name</b></p>
             <v-text-field
              outlined
              dense
              rounded
              type="text"
              v-model="part_name"
            ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Material Part Code</b></p>
             <v-text-field
              outlined
              dense
              rounded
              type="text"
              v-model="part_code"
            ></v-text-field>
        </v-col>
         <v-col cols="12" sm="3">
            <p><b>Specification</b></p>
             <v-text-field
              outlined
              dense
              rounded
              type="text"
              v-model="specification"
            ></v-text-field>
        </v-col>
        </v-row>
        
        <v-row justify="center" dense v-if="inventory_composite_material && part_name && part_code">
          <v-btn color="warning" @click="saveInventoryMaterialPart()" :loading="loader"
            >Add</v-btn
          >
        </v-row>
       </v-card>

     <v-card class="box" v-if="inventory_material_part_list!='' ">
     <v-data-table  :headers="headers" :items="inventory_material_part_list" :items-per-page="-1">
        <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Inventory Material Part List</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </template>
         <template v-slot:[`item.isactive`]="{ item }">
                 <v-switch v-model="item.isactive"  @change="toggleIsactiveInventoryInventoryMaterialPart(item)"
                 :color="item.isactive ? 'success' : 'primary'"></v-switch>
      </template>
       <template v-slot:[`item.delete`]="{ item }">
            <v-avatar size="35">
              <v-icon
                class="mr-4 v-icon-size"
                color="red"
                @click="deleteInventoryInventoryMaterialPart(item)"
                >mdi-trash-can</v-icon
              >
            </v-avatar>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <v-avatar size="35">
              <v-icon
                class="mr-4 v-icon-size"
                color="red"
                @click="editDetail(item)"
                >mdi-pencil</v-icon
              >
            </v-avatar>
          </template>
           <template v-slot:[`item.islast`]="{ item }">
            <span v-if="item.islast">
              <v-icon class="mr-2 v-icon-size" color="success"
                >mdi-check-circle-outline</v-icon
              >
            </span>
            <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error"
                >mdi-close-circle-outline</v-icon
              >
            </span>
          </template>
     </v-data-table>
 </v-card>

         <v-dialog
        v-model="dialog_edit"
        persistent
        scrollable="false"
        max-width="1200px"
        transition="dialog-bottom-transition"
      >
        <v-card class="box">
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Edit Material Specification</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <br>
            <v-row justify="center" dense>
            <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Material</b></p>
                <v-autocomplete
                color="#0F2027"
                dense
                rounded
                required
                v-model="editedItem.inventory_composite_material"
                :items="inventory_composite_material_list"
                item-text="name"
                item-value="id"
                label="Material"
                outlined
                disabled
                />
        </v-col>
        </v-row>
        <v-row justify="center" dense >
            <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Material Part Name</b></p>
             <v-text-field
              outlined
              dense
              rounded
              type="text"
              v-model="editedItem.part_name"
            ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Material Part Code</b></p>
             <v-text-field
              outlined
              dense
              rounded
              type="text"
              v-model="editedItem.part_code"
            ></v-text-field>
        </v-col>
         <v-col cols="12" sm="3">
            <p><b>Specification</b></p>
             <v-text-field
              outlined
              dense
              rounded
              type="text"
              v-model="editedItem.specification"
            ></v-text-field>
        </v-col>
        </v-row>
          </v-card-text>
          <br />
          <v-row justify="center">
            <v-btn color="primary" :loading="loader" @click="saveUpdateInventoryInventoryMaterialPart()"
              >Update</v-btn
            >
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="dialog_edit = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      inventory_composite_material_list:[],inventory_composite_material:"",
      inventory_material_part_list:[],specification:"",part_name:"",part_code:"",
      headers:[
      { text: "SR No", value: "srno" },
      { text: "Material", value: "invmaterial" },
      { text: "Name", value: "name" },
      { text: "Code", value: "code" },
      { text: "Specification", value: "specification" },
      { text: "Is Active", value: "isactive" },
      { text: "Edit", value: "edit" },
      { text: "Delete", value: "delete" },
      ],
    dialog_edit: false,
    editedItem: {
      id: "",specification:"",inventory_composite_material:"",part_name:"",part_code:""
    },
  }),
   methods: {
      clearData(){
        this.part_name="",this.inventory_composite_material="",this.specification="",this.part_code=""
      },
      async saveUpdateInventoryInventoryMaterialPart(){
       this.overlay = true;
       this.loader = true;
        try {
          const res = await axios.post("/Inventory/saveUpdateInventoryInventoryMaterialPart", this.editedItem);
          if (res.data.flag == "YES") {
            this.inventory_material_part_list=res.data.inventory_material_part_list
            this.showSnackbar("green", "Updated Successfully"); // show snackbar  
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
         this.dialog_edit = false;
      }
    },
    editDetail(item) {
      this.editedItem.id = item.id;
      this.editedItem.specification = item.specification;
      this.editedItem.part_name = item.name;
      this.editedItem.part_code = item.code;
      this.editedItem.inventory_composite_material = item.invmaterial_id;
      this.dialog_edit = true;
    },
    async saveInventoryMaterialPart(){
        const data = {
        inventory_composite_material:this.inventory_composite_material,
        specification:this.specification,
        part_name:this.part_name,
        part_code:this.part_code,
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/saveInventoryMaterialPart", data);
          if (res.data.flag == "YES") {
            this.inventory_material_part_list=res.data.inventory_material_part_list
            this.showSnackbar("green", "Saved Successfully"); // show snackbar   
            this.clearData();
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
     async toggleIsactiveInventoryInventoryMaterialPart(item){
        const data = {
            id: item.id,
            isactive: item.isactive,
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/toggleIsactiveInventoryInventoryMaterialPart", data);
          if (res.data.flag == "YES") {
             this.inventory_material_part_list=res.data.inventory_material_part_list
            this.showSnackbar("green", "Updated Successfully"); // show snackbar    
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
     async deleteInventoryInventoryMaterialPart(item){
       if (!confirm("Are You Sure You Want To Delete This Item?"))
        return;
        const data = {
            id: item.id,
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/deleteInventoryInventoryMaterialPart", data);
          if (res.data.flag == "YES") {
             this.showSnackbar("green", "Deleted Successfully"); // show snackbar    
             this.inventory_material_part_list=res.data.inventory_material_part_list
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
    async onLoad() {
      try {
          const res = await axios.post("/Inventory/getInventoryMaterialPartList");
          if (res.data.flag == "YES") {
            this.inventory_composite_material_list=res.data.inventory_composite_material_list
            this.inventory_material_part_list=res.data.inventory_material_part_list
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
     
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>